enum PopoverMenuType {
  EMAIL = 'email',
  PHONE = 'phone',
  OTHER = 'other',
}

export default PopoverMenuType;
